import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Dropdown} from 'semantic-ui-react';
import {Actions} from '../../../common/actions';

const options = [
  {'text': 'ACEPTADO', 'value': 'S'},
  {'text': 'NEGADO', 'value': 'N'},
];

class AcceptanceStatus extends Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(event, data) {
    const {claimCode} = this.props;
    this.props.updateReturnOrderValue(claimCode, data);
  }

  render() {
    const {isUserFromTDE, returnOrder, value} = this.props;

    if (isUserFromTDE && returnOrder.status === 'E') {
      return (
        <Dropdown selection compact
          name='acceptanceStatus'
          value={value || ''}
          options={options}
          onChange={this.handleChange}
        />
      );
    }

    if (!value) {
      return null;
    }
    
    return value === 'S' ? 'ACEPTADO' : 'NEGADO';
  }
}

const mapStateToProps = (state) => {
  return {
    'isUserFromTDE': state.session.isUserFromTDE,
    'returnOrder': state.partsReturnsOrders.selectedOrder,
  };
};

const {updateReturnOrderValue} = Actions;

export default connect(mapStateToProps, {
  updateReturnOrderValue,
})(AcceptanceStatus);
